var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"stat-pie",staticStyle:{"width":"450px"},attrs:{"title":_vm.title}},[_c('ApexCharts',{staticStyle:{"min-width":"100%"},attrs:{"height":"275px","type":"pie","options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }